// sexo: 'M' = masculino, 'F' = femenino
// Recibe (sexo, nroDoc) y devuelve el CUIL como string de 11 dígitos
function generarCuil(sexo, nroDoc) {
  const dniStr = String(nroDoc).padStart(8, "0");
  const coef = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

  // prefijo según sexo ('M' => 20, cualquier otro => 27)
  let prefijo = sexo && String(sexo).toUpperCase() === "M" ? 20 : 27;

  // función auxiliar para calcular dígito verificador con un prefijo dado
  const calcularVerificador = (pref) => {
    const cadena = String(pref) + dniStr;

    // Validación opcional para imitar el parse estricto de C# (solo dígitos)
    if (!/^\d{10}$/.test(cadena)) {
      throw new Error("DNI y prefijo deben ser numéricos.");
    }

    const suma = cadena
      .split("")
      .reduce((acc, ch, i) => acc + Number(ch) * coef[i], 0);
    const resto = suma % 11;
    let verificador = 11 - resto;
    if (verificador === 11) verificador = 0;
    return verificador;
  };

  // cálculo inicial
  let verificador = calcularVerificador(prefijo);

  // si el verificador da 10, se usa prefijo alternativo 23 y se recalcula
  if (verificador === 10) {
    prefijo = 23;
    verificador = calcularVerificador(prefijo);
  }

  return `${prefijo}${dniStr}${verificador}`;
}

const cuilHelper = {
  generarCuil,
};

export default cuilHelper;


